import style from './laser.module.css';

export default function Logo() {
    return <div className={style.logo}>
        <img src="/laser.png" alt="Logo" />
    </div>
}
